// src/components/Admin/TileBuilder/ChartTypeSelector.tsx
import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, SelectChangeEvent } from '@mui/material';
import { chartOptions } from '../../../support/customTileTransformUtils';

interface ChartTypeSelectorProps {
  chartType: string;
  setChartType: (chartType: string) => void;

  // NEW: update chart settings alongside chart type (needed for bar orientation)
  setSettings?: (next: Record<string, any>) => void;

  size?: 'small' | 'medium';
  fullWidth?: boolean;
  label?: string;
}

const deriveBarLayoutFromChartType = (type: string): 'vertical' | 'horizontal' => {
  const t = (type || '').toLowerCase();
  return t.includes('horizontal') ? 'horizontal' : 'vertical';
};

const ChartTypeSelector: React.FC<ChartTypeSelectorProps> = ({
  chartType,
  setChartType,
  setSettings,
  size = 'small',
  fullWidth = true,
  label = 'Chart Type',
}) => {
  const labelId = 'chart-type-select-label';

  const handleChange = (e: SelectChangeEvent<string>) => {
    const nextType = e.target.value as string;

    // Always update the chart type
    setChartType(nextType);

    // If bar charts encode orientation in the chart type, keep settings in sync.
    if (setSettings && nextType.toLowerCase().includes('bar_chart')) {
      setSettings({ layout: deriveBarLayoutFromChartType(nextType) });
    }
  };

  return (
    <FormControl size={size} fullWidth={fullWidth}>
      <InputLabel id={labelId}>{label}</InputLabel>
      <Select labelId={labelId} label={label} value={chartType ?? ''} onChange={handleChange}>
        {chartOptions.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default ChartTypeSelector;